import Swiper from 'swiper';

function Tags($element, options = {}) {
    this.$element = $element;

    this.swiper = new Swiper(this.$element, {
        slidesPerView: 'auto',
        spaceBetween: 4,
        touchStartForcePreventDefault: true,
        on: {
            init: (swiper) => {
                if (options.useShadow) {
                    this.updateShadow(swiper);
                }
            }
        },
        breakpoints: {
            960: {
                spaceBetween: 8,
            },
        },
    });

    if (options.useShadow) {
        this.swiper.el.classList.add('Tags__shadow');

        this.swiper.on('slideChange', (swiper) => {
            this.updateShadow(swiper);
        });
    }
}

Tags.prototype.updateShadow = function(swiper) {
    if (!swiper) return;

    this.setShadows(swiper, swiper.isEnd ? 'begin' : 'end');
}

Tags.prototype.setShadows = function(swiper, ...shadows) {
    if (!shadows.length) return;

    const $element = swiper.el;

    const classNameOfShadows = shadows.map((shadow) => {
        return `Tags__shadow--${shadow}`;
    });

    const classNamesOfElement = $element.classList.value;
    const everyClassNameExist = classNameOfShadows.every((classNameOfShadow) => {
        return classNamesOfElement.includes(classNameOfShadow);
    });
    
    if (!everyClassNameExist) {
        $element.classList.forEach((className) => {
            if (className.includes('Tags__shadow--')) {
                $element.classList.remove(className);
            }
        });
    
        $element.classList.add(...classNameOfShadows);
    }
}

export default Tags;
